import FacebookIcon from '../../assets/facebook-icon.svg';
import LinkedinIcon from '../../assets/linkedin-icon.svg';
import InstagramIcon from '../../assets/instagram-icon.svg';
import TwitterIcon from '../../assets/twitter-icon.svg';

const Footer = () => {
  const socialsUrl = [
    {
      icon: FacebookIcon,
      link: process.env.REACT_APP_TWYGS_FACEBOOK_URL
    },
    {
      icon: InstagramIcon,
      link: process.env.REACT_APP_TWYGS_INSTAGRAM_URL
    },
    {
      icon: LinkedinIcon,
      link: process.env.REACT_APP_TWYGS_LINKEDIN_URL
    },
    {
      icon: TwitterIcon,
      link: process.env.REACT_APP_TWYGS_TWITTER_URL
    }
  ];

  const policyUrl = [
    {
      text: 'Cookie Policy',
      link: `${process.env.REACT_APP_MAIN_URL}cookie-policy`
    },
    {
      text: 'Privacy Policy',
      link: `${process.env.REACT_APP_MAIN_URL}privacy-policy`
    },
    {
      text: 'Terms of Use',
      link: `${process.env.REACT_APP_MAIN_URL}terms-of-use`
    }
  ];

  return (
    <div className="flex flex-col gap-4 items-center p-4 mt-[20px] 2xl:mt-[36px] border-t border-05-seasalt-white">
      <div className="flex gap-4">
        {socialsUrl.map((social, index) => (
          <a
            key={index}
            href={social.link}
            target="_blank"
            rel="noreferrer"
            className="hover:opacity-70 cursor-pointer"
          >
            <img src={social.icon} className="w-4 h-4" alt="" />
          </a>
        ))}
      </div>
      <div className="flex gap-3">
        {policyUrl.map((policy, index) => (
          <a
            key={index}
            href={policy.link}
            target="_blank"
            rel="noreferrer"
            className="hover:opacity-70 font-[600] text-xs md:text-sm"
          >
            {policy.text}
          </a>
        ))}
      </div>
      <div className="font-[600] text-xs md:text-sm">© Twygs 2024. All rights reserved.</div>
    </div>
  );
};

export default Footer;
